export const trainerTexts = {
    pl: {
        header_primary: 'Informator',
        header_secondary: 'Panel Trenera',
        log_as: 'Jesteś zalogowany/a jako:',
        your_games: 'Twoje gry',
        your_games_end: 'Pokaż zakończone gry',
        your_games_running: 'Pokaż trwające gry',
        your_games_prepared: 'Pokaż przygotowane gry',
        languages: 'Możesz przeglądać tę stronę w następujących językach',
        languages_polish: 'Polski',
        languages_english: 'English',
        languages_update: 'Zmień',
        licenses_left: 'Pozostało licencji: ',
        login_prompt: 'Zaloguj się na swoje konto',
        login_confirm: 'Zaloguj się',
        forgot_pass: 'Nie pamiętasz hasła?',
        click_here: 'Kliknij tutaj!',
        send: 'Wyślij',
        create_game: 'Stwórz nową grę',
        refresh: 'Odśwież',
        logout: 'Wyloguj >',
        enter_new_pass: 'Podaj swoje nowe hasło',
        game_status: 'Status gry:',
        game: 'Gra',
        lang: 'język',
        game_active: 'Aktywna',
        game_end: 'Zakończona',
        game_inactive: 'Nieaktywna',
        links_set: 'Zestaw linków',
        trainer: 'Trener',
        copy: 'Skopiuj!',
        delete_game: 'Usuń grę!',
        players: 'Graczy:',
        activate_game: 'Uruchom grę!',
        continue_game: 'Kontynuuj!',
        show_results: 'Pokaż wyniki',
        add_player: 'Gracz +',
        subtr_player: 'Gracz - ',
        find_us: 'Znajdź nas:',
        you_sure: 'Na pewno?',
        cant_change_players: 'Nie będzie można zmienić już liczby graczy',
        cancel_create: 'Nie, jednak nie',
        confirm_create: 'Tak, grajmy już!',
    },
    eng: {
        header_primary: 'Informer',
        header_secondary: "Trainer's panel",
        log_as: 'You are logged as:',
        your_games: 'Your games:',
        your_games_end: 'Your finished games',
        your_games_running: 'Your running games',
        your_games_prepared: 'Your prepared games',
        languages: 'You can browse this page in the following languages',
        languages_polish: 'Polish',
        languages_english: 'English',
        languages_update: 'Change',
        licenses_left: 'Licenses left: ',
        login_prompt: 'Please login into your account',
        login_confirm: 'Login',
        forgot_pass: 'Forgot your password?',
        click_here: 'Click here!',
        send: 'Send',
        create_game: 'Create game',
        refresh: 'Refresh',
        logout: 'Logout >',
        enter_new_pass: 'Enter new pass',
        game_status: 'Game status:',
        game: 'Game',
        lang: 'Language',
        game_active: 'Active',
        game_end: 'Finished',
        game_inactive: 'Not activated',
        links_set: 'Links set',
        trainer: 'Trainer',
        copy: 'Copy!',
        delete_game: 'Delete game!',
        players: 'Players:',
        activate_game: 'Activate game!',
        continue_game: 'Continue game!',
        show_results: 'Show Results',
        add_player: 'Player +',
        subtr_player: 'Player - ',
        find_us: 'Find us:',
        you_sure: 'Are you sure?',
        cant_change_players: 'Players count change will be no longer possible',
        cancel_create: 'No, changed my mind',
        confirm_create: 'Yeah, lets play already',
    },
};
